<div class="home-background">
    <div class="blur"></div>
</div>
<div mat-card class="txp-home__card">
    <div class="home-card-image"></div>
    <div class="home-card-content">
        <div mat-card-title class="txp-home__logo"></div>
        <div mat-card-content class="txp-home__content">
            <txp-message
                [type]="messageType.DANGER"
                data-qa-label="AuthErrorMessage">
                {{ errorDescription }}
            </txp-message>
            <txp-button
                data-qa-label="TryAgainButton"
                [style]="buttonStyle.PRIMARY"
                (click)="loginFresh()">
                Log In with a Different Account
            </txp-button>
        </div>
    </div>
</div>
